import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-bt--caption _tc--light" }
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_localize = _resolveComponent("localize")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_backer_center_header = _resolveComponent("backer-center-header")

  return (_openBlock(), _createElementBlock("div", {
    class: "_flex _flexcol _pa-2 _pa-5--m",
    "data-qa": `backer-center-payments-list-item:${$props.paymentID}`
  }, [
    _createVNode(_component_backer_center_header, null, {
      prefix: _withCtx(() => [
        _createVNode(_component_backer_center_thumbnail, {
          url: $props.yourPledgeUrl,
          "image-url": $props.projectImageUrl,
          name: $props.name
        }, null, 8 /* PROPS */, ["url", "image-url", "name"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_base_text, {
          as: "a",
          level: "b1",
          href: $options.formattedYourPledgeUrl,
          class: "_toe",
          title: $props.name,
          "data-qa": "backer-center-payments-list-item-data:ProjectUrl"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "title"]),
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString($options.formattedDate) + " ", 1 /* TEXT */),
          ($options.hasInstallments)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "•", -1 /* CACHED */)),
                _createVNode(_component_localize, {
                  resource: _ctx.Resources.BackerCenter.XOfYInstallmentLabel
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString($props.installmentSequenceNumber), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_4, _toDisplayString($props.numberOfInstallmentsInPlan), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      suffix: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass($options.amountClasses),
          "data-qa": "backer-center-payments-list-item-data:Amount"
        }, _toDisplayString($options.formattedAmount), 3 /* TEXT, CLASS */),
        ($options.hasActions)
          ? (_openBlock(), _createBlock(_component_balloon_actions, {
              key: 0,
              actions: $options.balloonActions,
              theme: "lightOutline",
              mode: _ctx.balloonActionsModes.grouped,
              "balloon-style-props": $options.balloonStyleProps,
              "data-qa": "payments-card:Actions"
            }, null, 8 /* PROPS */, ["actions", "mode", "balloon-style-props"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 8 /* PROPS */, _hoisted_1))
}